<template>
  <div id="collapse-1" class="collapse border-0 mx-auto col-12 pl-0 px-0">
    <div class="card px-0 my-2 mx-auto col-12">
      <div class="card-body">
        <button v-if="Number(surveyTypeId) === 1" class="btn btn-secondary mr-2 px-2" @click.prevent="admin_excluded">
          Set optional questions
        </button>
        <button class="btn btn-secondary mr-2 px-2" @click.prevent="admin_mailtext">
          Change mail subject/text
        </button>
        <button class="btn btn-secondary mr-2 px-2" @click.prevent="admin_reimport">
          Re-import answers
        </button>
        <button class="btn btn-secondary mr-2 px-2" @click.prevent="admin_addon">
          Add-on Survey
        </button>

        <div v-if="administer_excluded" class="py-4">
          <h5>Optional questions</h5>
          <div
            v-for="q in excludablequestions"
            :key="q.generalquestion_id"
            class="row px-0 mx-0 py-0 my-0"
          >
            <div class="form-check">
              <input
                type="checkbox"
                :id="q.generalquestion_id"
                :value="q.generalquestion_id"
                :checked="excludedquestions.includes(q.generalquestion_id)"
                class="btn-check"
                @change="toggleExcluded(q.generalquestion_id)"
              />
              <label :for="q.generalquestion_id" class="btn btn-outline-light text-dark">
                <fa-icon v-if="!excludedquestions.includes(q.generalquestion_id)" icon="times" class="mr-1" />
                <fa-icon v-if="excludedquestions.includes(q.generalquestion_id)" icon="plus" class="mr-1 mb-1 mt-0 pt-0" />
                <span class="mt-1" :class="excludedquestions.includes(q.generalquestion_id) ? 'gdq-strike' : ''">
                  {{ q.generalquestion_text }}
                </span>
              </label>
            </div>
          </div>
          <button class="btn btn-primary" @click.prevent="admin_excluded_save">
            Save optional questions
          </button>
        </div>

        <div v-if="administer_mailtext" class="py-4">
          <h5>Mailtexts</h5>
          <div class="mb-3">
            <label class="form-label">Invitation E-mail Subject Line</label>
            <input
              :value="survey_invitation_subject"
              class="form-control col-12"
              @input="survey_invitation_subject = $event.target.value"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Invitation E-mail Personal Text</label>
            <BaseEditor
              :model-value="survey_invitation_consultant_text"
              :editor-toolbar="editortoolbar"
              @update:model-value="survey_invitation_consultant_text = $event"
            />
          </div>
          <button class="btn btn-primary" @click.prevent="admin_mailtext_save">
            Save mail text
          </button>
        </div>

        <div v-if="administer_reimport" class="py-4">
          <div
            v-if="reimportstatus"
            :class="['alert', 'alert-dismissible', 'fade', 'show', Number(reimportstatus) === 2 ? 'alert-danger' : 'alert-success']"
            role="alert"
          >
            <span v-if="Number(reimportstatus) === 2">Data for import was not found</span>
            <span v-if="Number(reimportstatus) === 1">Import done.</span>
            <button type="button" class="btn-close" aria-label="Close" @click="reimportstatus = 0" />
          </div>
          <h5>Re-import answers</h5>
          This function will attempt to re-import the survey answers (GDQ and general) from the old system. You can
          run this function more than once for a survey without doing any damage.
          <div v-show="reimporting > 0" class="row mx-1">
            <h5>Re-importing {{ reimporting }} of {{ surveymembersCount }}</h5>
          </div>
          <div v-show="Number(reimporting) === -1" class="row">
            <button class="btn btn-primary mt-2 mx-3" @click.prevent="reimport">
              Re-import answers
            </button>
            <button class="btn btn-danger mt-2 mx-3" @click.prevent="admin_reimport">
              Cancel
            </button>
          </div>
        </div>

        <div v-if="administer_addon" class="py-4">
          <select
            :value="addon_survey"
            class="form-select"
            @change="addon_survey = $event.target.value; saveField('addon_survey', $event.target.value)"
          >
            <option v-for="option in addonsurveys" :key="option.value" :value="option.value">{{ option.text }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseEditor from './base/BaseEditor.vue'

const editortools = [
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  ['bold', 'italic'],
  [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
  [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
  [{ color: [] }],
  ['image']
]

export default {
  name: 'GroupSurveyAdminPanel',
  components: { BaseEditor },
  props: {
    surveyTypeId: { type: [Number, String], default: null }
  },
  emits: ['survey-updated'],
  data () {
    return {
      editortoolbar: editortools,
      administer_excluded: false,
      excludablequestions: [],
      excludedquestions: [],
      administer_mailtext: false,
      administer_reimport: false,
      administer_addon: false,
      reimporting: -1,
      reimported: [],
      reimportstatus: 0,
      addonsurveys: [],
      survey_invitation_subject: '',
      survey_invitation_consultant_text: '',
      addon_survey: 0
    }
  },
  computed: {
    survey_id () { return this.$store.state.currentsurvey.id },
    surveymembersCount () { return this.$store.state.currentsurveymembers.length }
  },
  watch: {
    '$store.state.currentsurvey.survey_invitation_subject' (val) { this.survey_invitation_subject = val || '' },
    '$store.state.currentsurvey.survey_invitation_consultant_text' (val) { this.survey_invitation_consultant_text = val || '' },
    '$store.state.currentsurvey.addon_survey' (val) { this.addon_survey = val || 0 }
  },
  created () {
    const s = this.$store.state.currentsurvey
    this.survey_invitation_subject = s.survey_invitation_subject || ''
    this.survey_invitation_consultant_text = s.survey_invitation_consultant_text || ''
    this.addon_survey = s.addon_survey || 0
    this.addonsurveys_get()
  },
  methods: {
    saveField (fieldname, value) {
      const data = { id: this.survey_id, [fieldname]: value }
      this.$store.dispatch('groupsurvey_save', { survey: data })
    },
    admin_excluded () {
      this.excludablequestions_get()
      this.administer_excluded = !this.administer_excluded
      if (this.administer_excluded) {
        this.administer_mailtext = false
        this.administer_reimport = false
        this.administer_addon = false
      }
    },
    excludablequestions_get () {
      this.excludablequestions = []
      this.excludedquestions = []
      this.$store.dispatch('excludedquestions_fetch', { survey_id: this.survey_id })
        .then(resp => {
          this.excludablequestions = resp.data.questions
          for (let i = 0; i < resp.data.questions.length; i++) {
            if (Number(resp.data.questions[i].excluded) === 1) {
              this.excludedquestions.push(resp.data.questions[i].generalquestion_id)
            }
          }
        })
    },
    async admin_excluded_save () {
      await this.$store.dispatch('excludedquestions_save', { survey_id: this.survey_id, questions: this.excludedquestions })
      this.administer_excluded = false
    },
    toggleExcluded (id) {
      const arr = [...this.excludedquestions]
      const idx = arr.indexOf(id)
      if (idx >= 0) arr.splice(idx, 1)
      else arr.push(id)
      this.excludedquestions = arr
    },
    admin_mailtext () {
      this.administer_mailtext = !this.administer_mailtext
      if (this.administer_mailtext) {
        this.administer_excluded = false
        this.administer_reimport = false
        this.administer_addon = false
      }
    },
    admin_mailtext_save () {
      const data = {
        id: this.survey_id,
        survey_invitation_subject: this.survey_invitation_subject,
        survey_invitation_consultant_text: this.survey_invitation_consultant_text
      }
      this.$store.dispatch('groupsurvey_save', { survey: data }).then(() => {
        this.$emit('survey-updated')
        this.administer_mailtext = false
      })
    },
    admin_addon () {
      this.administer_addon = !this.administer_addon
      if (this.administer_addon) {
        this.administer_excluded = false
        this.administer_reimport = false
        this.administer_mailtext = false
      }
    },
    admin_reimport () {
      this.reimporting = -1
      this.administer_reimport = !this.administer_reimport
      if (this.administer_reimport) {
        this.administer_excluded = false
        this.administer_mailtext = false
        this.administer_addon = false
      }
    },
    async reimport () {
      const surveymembers = this.$store.state.currentsurveymembers
      this.reimported = []
      this.reimportstatus = 0
      for (let i = 0; i < surveymembers.length; i++) {
        this.reimporting = i + 1
        await this.$store.dispatch('legacyanswers_get', { surveymember_id: surveymembers[i].id })
          .then(resp => { if (resp.data.old_id === '0') this.reimportstatus = 2 })
      }
      if (Number(this.reimportstatus) === 0) this.reimportstatus = 1
      this.$emit('survey-updated')
      this.reimporting = -1
    },
    addonsurveys_get () {
      this.$store.dispatch('record_readlist', { table_name: 'g_addon_surveys', orderby: 'survey_name' })
        .then(resp => {
          const options = [{ value: 0, text: '-- No add-on survey --' }]
          for (const r of resp.data.result) {
            options.push({ value: r.id, text: r.survey_name })
          }
          this.addonsurveys = options
        })
    }
  }
}
</script>

<style scoped>
.gdq-strike {
  text-decoration: line-through;
}
</style>
